import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOALegalActions() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ legalActions, setLegalActions ] = useState(powerOfAttorney.legal_actions || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../legal-actions');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      legal_actions: legalActions
    }));
    navigate('../personal-family-care');
  }, [ legalActions, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-legal-actions screen-container screen">
      <ScreenHeader
        title="Legal Actions"
        description="Decide whether to grant your agent power to take legal action on your behalf"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Legal Action Powers?</h3>
        <p>
          Legal action powers allow your agent to represent you in legal matters 
          and take legal action on your behalf. This includes:
        </p>
        <ul className="legal-actions-list">
          <li>Filing lawsuits and legal claims</li>
          <li>Defending against lawsuits</li>
          <li>Settling legal disputes</li>
          <li>Hiring and working with attorneys</li>
          <li>Signing legal documents and contracts</li>
          <li>Handling court proceedings</li>
          <li>Managing legal settlements</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>Initiate or defend legal proceedings</li>
          <li>Hire attorneys and legal professionals</li>
          <li>Negotiate settlements on your behalf</li>
          <li>Sign legal documents and agreements</li>
          <li>Represent your interests in court</li>
          <li>Make legal decisions affecting your rights</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="legal-actions-yes"
            label="Yes"
            description="Grant power to take legal actions"
            value="yes"
          />
          <AssetDistributionOption
            id="legal-actions-no"
            label="No"
            description="Do not grant power to take legal actions"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Legal action powers give your agent broad authority to make legal decisions 
            that could significantly impact your rights and finances. Choose this power 
            carefully and ensure your agent understands your wishes.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
